export class ValuationBlockValueAdjustmentsConstants {
    static INHERIT_DATA_LABEL = "Inherit from valuation run";
    static VALUE_ADJUSTMENTS_SUCCESSFULLY_INHERITED_MSG = "Value adjustments successfully inherited from the valuation run";
    static MODAL_OPTIONS = {
        size: "xl", centered: true, backdrop: "static", keyboard: false
    };
}
